import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { internalUseOnlyPriority4 } from "./H4";
const Title4Styled = styled.div.withConfig({
  componentId: "sc-1dcwt4x-0"
})(["", ";"], internalUseOnlyPriority4);
/**
 * Titles are styled to be parents of text. A title style may or may not correspond directly with an HTML heading (H1, H2, etc).
 */

const Title4 = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Title4Styled, props, children);

export default Title4;
Title4.propTypes = {
  /** Content inside title */
  children: PropTypes.node.isRequired
};